import { Column } from "@/constants/pipeline";
import { Handover } from "@/models/pipeline";
import { Row } from "./Row";
import { RowContent } from "./RowContent";
import { ApplicationDropdown } from "./ApplicationDropdown";

type HandoverRowProps = {
  data: Handover;
  columns: Column[];
  isPinned: boolean;
  isDepartmentView?: boolean;
  onTogglePin: (id: string) => void;
};

export const HandoverRow = ({ data, columns, isPinned, isDepartmentView = false, onTogglePin }: HandoverRowProps) => {
  return (
    <Row id={data.applicationId!} data={data}>
      <RowContent
        columns={columns}
        children={[
          <span className="truncate">{data.customerName}</span>,
          <span className="truncate">{data.allocatedToUserName}</span>,
          <div className={!data.handoverToUserId ? "text-slate-700/50" : ""}>
            {data.handoverToUserName ? data.handoverToUserName : "Select agent"}
          </div>,
          <span className="truncate">{data.note}</span>,
          <ApplicationDropdown
            applicationId={data.applicationId?.toString()}
            isPinned={isPinned}
            isDepartmentView={isDepartmentView}
            onTogglePin={onTogglePin}
          />,
        ]}
      />
    </Row>
  );
};
